module.exports = __webpack_public_path__ + "static/media/crystal-theme.a3f88ec4.wav";